export const DEFAULT_RANGE_FORMAT = 'YYYY/MM/DD';
export const DATE_TIME_NO_SEC = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_NO_SEC_AMPM = 'YYYY-MM-DD hh:mm A';
export const DATE_TIME = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_PRECISE = 'YYYY-MM-DD HH:mm:ss.SSS';

export const DATE = 'MMMM D, YYYY';
export const DATE_TIME_LONG = 'MMMM D, YYYY, HH:mm:ss';

export const DATE_MONTH_DAY = 'MMM D';
export const DATE_MONTH_DAY_YEAR = 'MMM D, YYYY';
export const DATE_SIMPLE = 'YYYY-MM-DD';
export const TIME = 'HH:mm:ss';
export const TIME_AMPM = 'h:mm A';
export const DATE_LONG_MONTH_WITH_OFFSET = 'MMMM D, YYYY HH:mm [GMT]Z';
export const DATE_TIME_WITH_OFFSET = 'YYYY-MM-DD HH:mm:ss [GMT]Z';
export const DATE_WITH_OFFSET = 'MMM DD, [GMT]Z';
export const DATE_TIME_SLASH = 'YYYY/MM/DD HH:mm';
export const DATE_MONTH_DAY_TIME = 'MMMM D, HH:mm';
export const DATE_MONTH_DAY_TIME_AMPM = 'MMMM D, hh:mm A';
